export const TokenHeader = 'X-Auth-Token';
